export default __webpack_public_path__ + "boxing.png";